import { AlertAction } from "../../ShellCommon/Controls/alert/alert";
import { AudioService } from "./audio-service";

export interface ActionRequiredAlertService {
  showAlert: (notification: ActionRequiredNotification) => void;
  hideAlert: (uId: string) => void;
}
export interface ActionRequiredNotification extends ActionRequiredNotificationBase {
  actions: AlertAction[];
  sound?: string;
  glyph?: string;
}

export interface ActionRequiredNotificationBase {
  notificationTitle: string;
  displayText?: string;
  timeout?: number;
  showTimer?: boolean;
  notificationId: string;
}

export class ActionRequiredAlertServiceImpl implements ActionRequiredAlertService {
  public actionItems: ActionRequiredNotification[] = [];

  // @ngInject
  constructor(
    private $rootScope: ng.IRootScopeService,
    private audioService: AudioService,
    private $timeout: ng.ITimeoutService
  ) {}
  public showAlert(notification: ActionRequiredNotification) {
    this.showAlertInternal(notification);
  }

  private showAlertInternal(notification: ActionRequiredNotification) {
    this.$rootScope.$applyAsync(() => {
      this.actionItems.push(notification);
      if (notification.sound) {
        this.audioService.play(notification.sound);
      }
      if (notification.timeout) {
        this.$timeout(() => {
          this.hideAlert(notification.notificationId);
        }, notification.timeout + 5000); // the alert will HIDE the notification after the timeout time. Then this will remove it from the DOM 5 seconds later to be safe.
      }
    });
  }

  public hideAlert(notificationId: string) {
    this.$rootScope.$applyAsync(() => {
      this.actionItems = this.actionItems.filter((item) => item.notificationId != notificationId);
    });
  }
}
